import type { Locale } from "./locales";

// Import every locale JSON eagerly. The catalogs are tiny (per-locale,
// one flat object of IDs -> strings), so we don't bother with lazy loading.
// Vite inlines each import, tree-shaking kills unused ones per SPA build.
import en from "./locales/en.json";
import ar from "./locales/ar.json";
import bn from "./locales/bn.json";
import de from "./locales/de.json";
import es from "./locales/es.json";
import fa from "./locales/fa.json";
import fr from "./locales/fr.json";
import ha from "./locales/ha.json";
import he from "./locales/he.json";
import hi from "./locales/hi.json";
import id from "./locales/id.json";
import it from "./locales/it.json";
import ja from "./locales/ja.json";
import ko from "./locales/ko.json";
import ms from "./locales/ms.json";
import my from "./locales/my.json";
import ne from "./locales/ne.json";
import nl from "./locales/nl.json";
import pl from "./locales/pl.json";
import pt from "./locales/pt.json";
import ro from "./locales/ro.json";
import ru from "./locales/ru.json";
import sv from "./locales/sv.json";
import sw from "./locales/sw.json";
import ta from "./locales/ta.json";
import te from "./locales/te.json";
import th from "./locales/th.json";
import tr from "./locales/tr.json";
import uk from "./locales/uk.json";
import ur from "./locales/ur.json";
import vi from "./locales/vi.json";
import yo from "./locales/yo.json";
import zhCN from "./locales/zh-CN.json";
import zhTW from "./locales/zh-TW.json";

export type MessageCatalog = Record<string, string>;

const CATALOGS: Record<Locale, MessageCatalog> = {
  en,
  ar,
  bn,
  de,
  es,
  fa,
  fr,
  ha,
  he,
  hi,
  id,
  it,
  ja,
  ko,
  ms,
  my,
  ne,
  nl,
  pl,
  pt,
  ro,
  ru,
  sv,
  sw,
  ta,
  te,
  th,
  tr,
  uk,
  ur,
  vi,
  yo,
  "zh-CN": zhCN,
  "zh-TW": zhTW,
};

/**
 * Returns messages for the given locale with English as the fallback for any
 * missing keys. This lets us ship the UI with partial translations without
 * breaking the app — untranslated strings appear in English.
 */
export function loadCatalog(locale: Locale): MessageCatalog {
  const target = CATALOGS[locale] ?? {};
  if (locale === "en") return target;
  return { ...CATALOGS.en, ...target };
}
